
import { useStore } from '@/store'
import { defineComponent, ref } from 'vue'
import { computed } from 'vue'
import pocketSettings from '@/settings/pocket-settings.json'
import FormOption from '@/components/Form/FormOption.vue'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import Analytics from '@/singletons/analytics'
import FormScrollableTab from '@/components/Abstract/FormScrollableTab.vue'

export default defineComponent({
  name: 'FormPocket',
  components: {
    FormScrollableTab,
    FormOption
  },
  props: {
    index: Number
  },
  setup() {
    const store = useStore()
    const configName = ref('configPocketId')
    const config = computed(() => store.getters[configName.value])
    const options = computed(() => pocketSettings.pocketTextures)

    const onClick = (option: any) => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_POCKET, option.id)
      Analytics.instance.sendPocketEvent(option.id)
    }

    return {
      config,
      configName,
      pocketSettings,
      onClick,
      options
    }
  }
})
